import React from 'react';
import PropTypes from 'prop-types';
import { Label } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

function Checkbox({
  checked,
  style,
  name,
  className,
  onClick,
  checkedClassName = 'text-accent',
  disabled = false,
  children,
  label
}) {
  const handleClick = () => {
    if (!disabled) {
      onClick({ name, checked })
    }
  }

  return (
    <Label check className={className} style={style} onClick={handleClick}>    
      {
          checked ? (
              <FontAwesomeIcon icon="check-square" className={checkedClassName}/>
          ) : (
              <FontAwesomeIcon icon={["far", "square"]}  />
          )
      }{' '}
      {children ?? label}
    </Label> 
  )
}

Checkbox.propTypes = {
  checked: PropTypes.bool.isRequired,
  style: PropTypes.object,
  className: PropTypes.string,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  children: PropTypes.string,
  label: PropTypes.string,
  checkedClassName: PropTypes.string,
}

export default Checkbox

